import type { MouseEvent, ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** 背景クリックで閉じたい場合だけ渡す(→ useConfirm や Trash の1枚操作は渡さず、誤タップでの取り消しを防ぐ) */
  onBackdropClick?: () => void;
}

/**
 * 確認・選択ダイアログ共通の外枠(背景+中央カード)。
 * 中身(文言・ボタン列)は呼び出し側が持つ(→ lib/confirm.tsx, RecurrenceScopeDialog, routes/Trash.tsx)。
 */
export default function DialogShell({ children, onBackdropClick }: Props) {
  function stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-70 flex items-center justify-center bg-black/40 p-6"
      onClick={onBackdropClick}
    >
      <div
        className="flex w-full max-w-[var(--dialog-w)] flex-col gap-4 rounded-2xl bg-white p-5 shadow-xl"
        onClick={stopPropagation}
      >
        {children}
      </div>
    </div>
  );
}
